import React from 'react';
import { StyleSheet, View } from 'react-native';
import { CachedVideo } from '../../components';

import { GROUP_MESSAGE } from '../../../constants/objectTypes';

export default class MessageVideo extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    // maybe should check id here?
    return this.props.currentMessage.video !== nextProps.currentMessage.video;
  }

  render() {
    const { currentMessage } = this.props;
    const { messageId, video } = currentMessage;

    const containerStyle = StyleSheet.flatten([
      styles.container,
      styles.groupChatModeContainerStyle,
    ]);

    const objectType = GROUP_MESSAGE;
    this._attachment = attachmentConfig = {
      objectType,
      objectId: messageId,
      fileName: video,
    };

    return (
      <View style={containerStyle}>
        <CachedVideo attachment={attachmentConfig} isThumb={true} />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {},
  groupChatModeContainerStyle: {},
});

MessageVideo.defaultProps = {
  currentMessage: {
    // video: null,
  },
  containerStyle: {},
};
